import api from 'utils/api';

export const getSupportDataType = (adminRole) =>
  adminRole?.toLowerCase() === 'administrator' ? 'support' : 'by_user';

const toQueryList = (value) =>
  (Array.isArray(value) ? value : value == null ? [] : [value])
    .map((item) => (item == null ? '' : String(item).trim()))
    .filter(Boolean)
    .join(',');

// A filter combination that matches nothing answers with a 404 envelope
// (`{ original: { status: 404, message: 'No Data Found' } }`) rather than an
// empty list, either as the body or through the axios error handler.
export const isEmptyTicketResponse = (response) => {
  if (response == null) return false;

  const status = response.status ?? response.original?.status;
  const message = response.message ?? response.original?.message ?? '';

  return (
    Number(status) === 404 ||
    String(message).toLowerCase().includes('no data found')
  );
};

export const requestGetSupportQueueTickets = ({
  page = 1,
  limit = 20,
  search = '',
  sortBy = 'created_at',
  sortType = 'desc',
  dataType = 'by_user',
  assignees = [],
  status = [],
  priority = [],
  tags = [],
} = {}) => {
  const params = new URLSearchParams({
    page,
    limit,
    sortby: sortBy,
    sorttype: sortType,
    search,
    support: 'true',
    data_type: dataType,
  });

  const assignee = toQueryList(assignees);
  const statusList = toQueryList(status);
  const priorityList = toQueryList(priority);
  const tagList = toQueryList(tags);

  if (assignee) params.set('assignee', assignee);
  if (statusList) params.set('status', statusList);
  if (priorityList) params.set('priority', priorityList);
  if (tagList) params.set('tags', tagList);

  return api.callGet(`admin/ticket?${params.toString()}`);
};

export const requestSaveTicket = (params) =>
  api.callPostFormData(`admin/ticket/add-ticket`, params);

export const requestSupportQueueStatusCount = (dataType = 'by_user') =>
  api.callGet(`admin/ticket/status-count?data_type=${dataType}`);

export const requestTicketFormData = () =>
  api.callGet(`admin/ticket/form-data`);

const asList = (value) => {
  if (Array.isArray(value)) return value;
  if (Array.isArray(value?.data)) return value.data;
  return [];
};

const normalizeFormItem = (item) => {
  if (item == null) return null;
  if (typeof item === 'string' || typeof item === 'number') {
    return { id: item, name: String(item) };
  }

  return {
    ...item,
    id: item.id ?? item.uuid ?? item.slug ?? item.name,
    name:
      item.name ??
      item.title ??
      item.label ??
      item.task ??
      item.value ??
      '',
    message: item.message ?? item.text ?? item.content ?? item.body ?? '',
  };
};

export const normalizeTicketFormData = (payload) => {
  const source = payload?.data && !Array.isArray(payload.data) ? payload.data : payload ?? {};

  return {
    tags: asList(source.tags ?? source.tag)
      .map(normalizeFormItem)
      .filter(Boolean),
    taskTypes: asList(
      source.task_type ??
      source.taskTypes ??
      source.tasks ??
      source.task ??
      source.services
    )
      .map(normalizeFormItem)
      .filter(Boolean),
    predefined: asList(
      source.predefined ??
      source.predefined_replies ??
      source.predefined_text ??
      source.predefinedTexts ??
      source.predefined_replies_list
    )
      .map(normalizeFormItem)
      .filter(Boolean),
  };
};

